<app-breadcrumb></app-breadcrumb>

<div class="subscription-container">
  <ion-grid class="stepper-container" [class.stepper-container--wide]="isRedesignedStep">
    <router-outlet></router-outlet>
  </ion-grid>
</div>
